import { createClient } from '@supabase/supabase-js';

export const CLINIC_ID = (import.meta.env.VITE_CLINIC_ID || 'XV').trim().toUpperCase();
export const APP_NAME = (import.meta.env.VITE_APP_NAME || 'XV Clinic').trim();

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

export const configurationError =
  !/^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(supabaseUrl) ||
  !supabaseAnonKey ||
  supabaseAnonKey.includes('PASTE_')
    ? 'Konfigurasi Supabase belum lengkap. Isi VITE_SUPABASE_URL dan VITE_SUPABASE_ANON_KEY.'
    : '';

export const supabase = configurationError
  ? null
  : createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    });
